module.exports = __webpack_public_path__ + "media/metaverse-2.dbd18471.mp4";